// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__wWbt7","dragIcon":"Choice_dragIcon__1I4vT","left":"Choice_left__2EeFL","input":"Choice_input__mOHLA"};